<template>
    <v-container fluid style="margin: 60px 10%">
        <v-row>
          <v-col cols="12">
            <v-data-table
            :items="eventos"
            :headers="eventosHeader"
            >
              <template v-slot:top>
                <v-toolbar flat color="white">
                  <v-toolbar-title>EVENTOS</v-toolbar-title>
                  <v-divider
                    class="mx-4"
                    inset
                    vertical
                  ></v-divider>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" x-large @click="CrudEvento('nuevo')">Nuevo Evento</v-btn>
                </v-toolbar>
              </template>
              <template v-slot:item.acciones="{ item }">
                <v-icon color="primary" class="mx-2" @click="verEvento(item.uid)">fas fa-eye</v-icon>
                <v-icon color="primary" class="mx-2" @click="CrudEvento('editar', item)">fas fa-edit</v-icon>
              </template>
            </v-data-table>
          </v-col>
          <v-dialog v-model="dialogEventos">
            <v-card v-if="eventoElegido">
              <v-card-title>
                <v-container>
                  <v-row>
                    <v-col cols="12" style="padding:60px 0" align="center">
                      <h2 v-if="nuevoEvento">Nuevo Evento</h2>
                      <h2 v-else>Actualizar Evento</h2>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field v-model="eventoElegido.tituloEs" solo :label="$t('Formularios.TituloEs')" :hint="$t('Formularios.TituloEs')"></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field v-model="eventoElegido.tituloEn" solo :label="$t('Formularios.TituloEn')" :hint="$t('Formularios.TituloEn')"></v-text-field>
                    </v-col>
                    <v-col cols="12" align="center">
                      <h2 class="my-5 headline vietnam black--text">{{ $t('Formularios.DescripcionEs') }}</h2>
                      <v-alert v-if="getCargandoAccion"><v-btn loading text color="error"></v-btn>{{ $t('Formularios.CargandoImagen') }}</v-alert>
                      <vue-editor style="word-break:break-word;" id="descripcionEs" v-model="eventoElegido.descripcionEs" useCustomImageHandler @image-added="handleImageAdded" />
                    </v-col>
                    <v-col cols="12" align="center">
                      <h2 class="my-5 headline vietnam black--text">{{ $t('Formularios.DescripcionEn') }}</h2>
                      <v-alert v-if="getCargandoAccion"><v-btn loading text color="error"></v-btn>{{ $t('Formularios.CargandoImagen') }}</v-alert>
                      <vue-editor style="word-break:break-word;" id="descripcionEn" v-model="eventoElegido.descripcionEn" useCustomImageHandler @image-added="handleImageAdded" />
                    </v-col>
                    <v-col cols="12">
                      <v-text-field v-model="eventoElegido.enlace" solo :label="$t('Formularios.Enlace')" :hint="$t('Formularios.Enlace')"></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-file-input v-model="preImagenEvento" solo :label="$t('Formularios.Imagen')" :hint="$t('Formularios.Imagen')"></v-file-input>
                    </v-col>
                    <v-col cols="6" align="center">
                      <h3 class="mb-3">Inicio</h3>
                      <v-date-picker v-model="eventoElegido.inicio"></v-date-picker>
                    </v-col>
                    <v-col cols="6" align="center">
                      <h3 class="mb-3">Final</h3>
                      <v-date-picker v-model="eventoElegido.final"></v-date-picker>
                    </v-col>
                    <v-col cols="12" align="center" style="padding-top: 60px">
                      <v-btn outlined style="border: 2px solid" x-large class="ma-3" @click="dialogEventos = false">Cerrar</v-btn>
                      <v-btn :loading="getCargandoAccion" x-large class="ma-3" color="primary white--text" v-if="nuevoEvento" @click="CrudEvento('publicar')">Publicar</v-btn>
                      <v-btn :loading="getCargandoAccion" x-large class="ma-3" color="primary white--text" v-else @click="CrudEvento('actualizar')">Actualizar</v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-title>
            </v-card>
          </v-dialog>
          <v-col cols="12" align="center" style="padding-top: 60px">
            <h1>Tours Artísticos</h1>
          </v-col>
          <v-col cols="12" align="center">
            <v-btn x-large color="primary white--text" @click="dialogTours = true">Modificar</v-btn>
          </v-col>
          <v-dialog v-model="dialogTours">
            <v-card v-if="tours">
              <v-card-title>
                <v-container>
                  <v-row>
                    <v-col cols="12" align="center" style="padding: 60px 0;">
                      <h1>Tours Artísticos</h1>
                    </v-col>
                    <v-col cols="12">
                      <v-file-input v-model="preImagenTours" solo :label="$t('Formularios.Imagen')" :hint="$t('Formularios.Imagen')" persistent-hint></v-file-input>
                    </v-col>
                    <v-col cols="12">
                      <v-img :src="tours.imagen"></v-img>
                    </v-col>
                    <v-col cols="12" align="center">
                      <h2 class="my-5 headline vietnam black--text">{{ $t('Formularios.DescripcionEs') }}</h2>
                      <v-alert v-if="getCargandoAccion"><v-btn loading text color="error"></v-btn>{{ $t('Formularios.CargandoImagen') }}</v-alert>
                      <vue-editor style="word-break:break-word;" id="descripcionEsTours" v-model="tours.descripcionEs" useCustomImageHandler @image-added="handleImageAdded" />
                    </v-col>
                    <v-col cols="12" align="center">
                      <h2 class="my-5 headline vietnam black--text">{{ $t('Formularios.DescripcionEn') }}</h2>
                      <v-alert v-if="getCargandoAccion"><v-btn loading text color="error"></v-btn>{{ $t('Formularios.CargandoImagen') }}</v-alert>
                      <vue-editor style="word-break:break-word;" id="descripcionEnTours" v-model="tours.descripcionEn" useCustomImageHandler @image-added="handleImageAdded" />
                    </v-col>
                    <v-col cols="12" style="padding-top: 40px">
                      <v-data-table :items="tours.pasajeros" :headers="headerPasajeros">
                        <template v-slot:top>
                          <v-toolbar flat color="white">
                            <v-toolbar-title>PASAJEROS</v-toolbar-title>
                            <v-divider
                              class="mx-4"
                              inset
                              vertical
                            ></v-divider>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" x-large @click="crudPasajeros('nuevo')">Nueva Cantidad</v-btn>
                          </v-toolbar>
                        </template>
                        <template v-slot:item.acciones="{item}">
                          <v-icon color="primary" @click="crudPasajeros('editar', item)">fas fa-edit</v-icon>
                        </template>
                      </v-data-table>
                      <v-dialog v-model="dialogPasajeros">
                        <v-card v-if="pasajero">
                          <v-card-title>
                            <v-container>
                              <v-row>
                                <v-col cols="12" align="center" style="padding: 60px 0;">
                                  <h1 v-if="nuevoPasajero">Nuevo Pasajero</h1>
                                  <h1 v-else>Actualizar Pasajero</h1>
                                </v-col>
                                <v-col cols="12">
                                  <v-text-field solo v-model="pasajero.cantidad" :label="$t('Formularios.Cantidad')" :hint="$t('Formularios.Cantidad')" persistent-hint></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                  <v-text-field solo v-model="pasajero.precio" :label="$t('Formularios.Precio')" :hint="$t('Formularios.Precio')" persistent-hint></v-text-field>
                                </v-col>
                                <v-col cols="12" align="center">
                                  <v-btn outlined style="border: 2px solid" x-large class="ma-3" @click="dialogPasajeros = false">Cerrar</v-btn>
                                  <v-btn x-large class="ma-3" color="primary white--text" v-if="nuevoPasajero" @click="crudPasajeros('publicar')">Publicar</v-btn>
                                  <v-btn x-large class="ma-3" color="primary white--text" v-else @click="crudPasajeros('actualizar')">Actualizar</v-btn>
                                </v-col>
                              </v-row>
                            </v-container>
                          </v-card-title>
                        </v-card>
                      </v-dialog>
                    </v-col>
                    <v-col cols="12" style="padding-top: 40px">
                      <v-data-table :items="tours.preferencias" :headers="headerPreferencias">
                        <template v-slot:top>
                          <v-toolbar flat color="white">
                            <v-toolbar-title>PREFERENCIAS</v-toolbar-title>
                            <v-divider
                              class="mx-4"
                              inset
                              vertical
                            ></v-divider>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" x-large @click="crudPreferencias('nuevo')">Nueva Preferencia</v-btn>
                          </v-toolbar>
                        </template>
                        <template v-slot:item.acciones="{item}">
                          <v-icon color="primary" @click="crudPreferencias('editar', item)">fas fa-edit</v-icon>
                        </template>
                      </v-data-table>
                      <v-dialog v-model="dialogPreferencias">
                        <v-card v-if="preferencia">
                          <v-card-title>
                            <v-container>
                              <v-row>
                                <v-col cols="12" align="center" style="padding: 60px 0;">
                                  <h1 v-if="nuevaPreferencia">Nueva Preferencia</h1>
                                  <h1 v-else>Actualizar Preferencia</h1>
                                </v-col>
                                <v-col cols="12">
                                  <v-text-field solo v-model="preferencia.tituloEs" :label="$t('Formularios.TituloEs')" :hint="$t('Formularios.TituloEs')" persistent-hint></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                  <v-text-field solo v-model="preferencia.tituloEn" :label="$t('Formularios.TituloEn')" :hint="$t('Formularios.TituloEn')" persistent-hint></v-text-field>
                                </v-col>
                                <v-col cols="12" align="center">
                                  <v-btn outlined style="border: 2px solid" x-large class="ma-3" @click="dialogPreferencias = false">Cerrar</v-btn>
                                  <v-btn x-large class="ma-3" color="primary white--text" v-if="nuevaPreferencia" @click="crudPreferencias('publicar')">Publicar</v-btn>
                                  <v-btn x-large class="ma-3" color="primary white--text" v-else @click="crudPreferencias('actualizar')">Actualizar</v-btn>
                                </v-col>
                              </v-row>
                            </v-container>
                          </v-card-title>
                        </v-card>
                      </v-dialog>
                    </v-col>
                    <v-col cols="12" style="padding-top: 40px">
                      <h2 class="mb-3">Horarios:</h2>
                      <v-chip v-for="i in tours.horarios" :key="i" class="ma-3" color="primary white--text">{{i}}</v-chip>
                    </v-col>
                    <v-col cols="12">
                      <v-switch v-model="tours.activado" label="Tours Artísticos Activado" color="primary"/>
                    </v-col>
                    <v-col cols="12" align="center">
                      <v-btn outlined style="border: 2px solid" x-large class="ma-3" @click="dialogTours = false">Cerrar</v-btn>
                      <v-btn :loading="getCargandoAccion" x-large class="ma-3" color="primary white--text" @click="actualizarTours()">Actualizar</v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-title>
            </v-card>
          </v-dialog>
          <v-col cols="12" align="center" style="padding-top: 60px;">
            <h1>GiftCard</h1>
            <h3>800 x 566px</h3>
          </v-col>
          <v-col cols="12" xs="12" md="4" align="center">
            <v-img :src="disenos.card1" class="mb-5" />
            <v-file-input solo v-model="preCard1" label="Subir Nueva Imagen"></v-file-input>
            <v-btn @click="actualizarGift('1')" color="primary white--text" x-large :loading="cargando1">Actualizar</v-btn>
          </v-col>
          <v-col cols="12" xs="12" md="4" align="center">
            <v-img :src="disenos.card2" class="mb-5" />
            <v-file-input solo v-model="preCard2" label="Subir Nueva Imagen"></v-file-input>
            <v-btn @click="actualizarGift('2')" color="primary white--text" x-large :loading="cargando2">Actualizar</v-btn>
          </v-col>
          <v-col cols="12" xs="12" md="4" align="center">
            <v-img :src="disenos.card3" class="mb-5" />
            <v-file-input solo v-model="preCard3" label="Subir Nueva Imagen"></v-file-input>
            <v-btn @click="actualizarGift('3')" color="primary white--text" x-large :loading="cargando3">Actualizar</v-btn>
          </v-col>
        </v-row>
    </v-container>
</template>

<script>
import * as firebase from 'firebase/app'
import 'firebase/firestore'
import { mapGetters, mapMutations } from 'vuex'
import axios from 'axios'
import { VueEditor } from 'vue2-editor'
export default {
  name: 'AdministracionExperiencias',
  components: {
    VueEditor
  },
  data () {
    return {
      eventos: [],
      eventosHeader: [
        { text: 'Titulo', value: 'tituloEs', align: 'center' },
        { text: 'Inicio', value: 'inicio', align: 'center' },
        { text: 'Final', value: 'final', align: 'center' },
        { text: 'Acciones', value: 'acciones', align: 'center' }
      ],
      dialogEventos: false,
      nuevoEvento: false,
      eventoElegido: null,
      preImagenEvento: null,
      // Tours
      dialogTours: false,
      preImagenTours: null,
      tours: null,
      headerPreferencias: [
        { text: 'Título Español', value: 'tituloEs', align: 'center' },
        { text: 'Título Inglés', value: 'tituloEn', align: 'center' },
        { text: 'Acciones', value: 'acciones', align: 'center' }
      ],
      dialogPreferencias: false,
      preferencia: null,
      indexPreferencia: null,
      nuevaPreferencia: true,
      headerPasajeros: [
        { text: 'Cantidad', value: 'cantidad', align: 'center' },
        { text: 'Precio', value: 'precio', align: 'center' },
        { text: 'Acciones', value: 'acciones', align: 'center' }
      ],
      dialogPasajeros: false,
      pasajero: null,
      indexPasajero: null,
      nuevoPasajero: true,
      headerHorarios: [
        { text: 'Horario', value: 'horario', align: 'center' },
        { text: 'Acciones', value: 'acciones', align: 'center' }
      ],
      dialogHorarios: false,
      horario: null,
      indexHorario: null,
      nuevoHorario: true,
      disenos: null,
      preCard1: null,
      cargando1: false,
      preCard2: null,
      cargando2: false,
      preCard3: null,
      cargando3: false
    }
  },
  mounted () {
    firebase.firestore().collection('utilidades').doc('giftcard').get().then(info => {
      this.disenos = info.data()
    })
    firebase.firestore().collection('eventos').get().then(info => {
      for (let i = 0; i < info.docs.length; i++) {
        this.eventos.push(info.docs[i].data())
      }
    })
    firebase.firestore().collection('utilidades').doc('tours').get().then(info => {
      this.tours = info.data()
    })
  },
  methods: {
    ...mapMutations(['setCargandoAccion', 'setAlerta', 'setTextoAlerta']),
    verEvento (uid) {
      var evento = `${this.$i18n.t('Alias.Eventos')}?${uid}`
      this.$router.push(evento)
    },
    CrudEvento (tipo, evento) {
      if (tipo === 'nuevo') {
        this.nuevoEvento = true
        this.eventoElegido = {
          tituloEs: null,
          tituloEn: null,
          descripcionEs: null,
          descripcionEn: null,
          enlace: null,
          imagen: null,
          inicio: null,
          final: null
        }
        this.dialogEventos = true
      } else if (tipo === 'editar') {
        this.nuevoEvento = false
        this.eventoElegido = evento
        this.dialogEventos = true
      } else if (tipo === 'publicar') {
        this.setCargandoAccion(true)
        if (this.preImagenEvento) {
          this.subirImagen(this.preImagenEvento, 'eventos').then(url => {
            this.eventoElegido.imagen = url
            this.eventoElegido.uid = firebase.firestore().collection('eventos').doc().id
            firebase.firestore().collection('eventos').doc(this.eventoElegido.uid).set(this.eventoElegido).then(() => {
              this.setCargandoAccion(false)
              this.dialogEventos = false
              this.eventos.push(this.eventoElegido)
              this.eventoElegido = null
              this.preImagenEvento = null
              this.setAlerta()
              this.setTextoAlerta('Evento Publicado Correctamente')
            })
          })
        } else {
          this.eventoElegido.uid = firebase.firestore().collection('eventos').doc().id
          firebase.firestore().collection('eventos').doc(this.eventoElegido.uid).set(this.eventoElegido).then(() => {
            this.setCargandoAccion(false)
            this.dialogEventos = false
            this.eventoElegido = null
            this.preImagenEvento = null
            this.setAlerta()
            this.setTextoAlerta('Evento Actualizado Correctamente')
          })
        }
      } else if (tipo === 'actualizar') {
        this.setCargandoAccion(true)
        if (this.preImagenEvento) {
          this.subirImagen(this.preImagenEvento, 'eventos').then(url => {
            this.eventoElegido.imagen = url
            firebase.firestore().collection('eventos').doc(this.eventoElegido.uid).update(this.eventoElegido).then(() => {
              this.setCargandoAccion(false)
              this.dialogEventos = false
              this.eventoElegido = null
              this.preImagenEvento = null
              this.setAlerta()
              this.setTextoAlerta('Evento Publicado Correctamente')
            })
          })
        } else {
          firebase.firestore().collection('eventos').doc(this.eventoElegido.uid).update(this.eventoElegido).then(() => {
            this.setCargandoAccion(false)
            this.dialogEventos = false
            this.eventoElegido = null
            this.preImagenEvento = null
            this.setAlerta()
            this.setTextoAlerta('Evento Actualizado Correctamente')
          })
        }
      }
    },
    subirImagen (file, lugar) {
      const reader = new FileReader()
      return new Promise(resolve => {
        reader.onload = ev => {
          axios({
            method: 'post',
            url: '/subir',
            crossDomain: true,
            data: {
              image: ev.target.result,
              tipo: 'sinMarca'
            }
          })
            .then(respuesta => {
              fetch(respuesta.data).then(res => res.blob()).then(blob => {
                var uploadTask = firebase.storage().ref(lugar).child(file.name).put(blob)
                uploadTask.on('state_changed', snapshot => {}, error => {
                  console.log(error)
                }, () => {
                  uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
                    axios({
                      method: 'post',
                      url: '/eliminar',
                      crossDomain: true,
                      data: {
                        url: respuesta.data
                      }
                    })
                    resolve(downloadURL)
                  })
                })
              })
            })
            .catch(error => {
              console.log(error)
            })
        }
        reader.readAsDataURL(file)
      })
    },
    handleImageAdded (file, Editor, cursorLocation, resetUploader) {
      this.setCargandoAccion(true)
      this.subirImagen(file, 'eventos').then(url => {
        Editor.insertEmbed(cursorLocation, 'image', url)
        resetUploader()
        this.setCargandoAccion(false)
      })
    },
    // Tours
    crudPreferencias (tipo, preferencia) {
      if (tipo === 'nuevo') {
        this.preferencia = {
          tituloEs: null,
          tituloEn: null
        }
        this.nuevaPreferencia = true
        this.dialogPreferencias = true
      } else if (tipo === 'editar') {
        this.preferencia = preferencia
        this.indexPreferencia = this.tours.preferencias.indexOf(preferencia)
        this.dialogPreferencias = true
        this.nuevaPreferencia = false
      } else if (tipo === 'publicar') {
        this.tours.preferencias.push(this.preferencia)
        this.dialogPreferencias = false
        this.preferencia = null
      } else if (tipo === 'actualizar') {
        this.tours.preferencias[this.indexPreferencia] = this.preferencia
        this.dialogPreferencias = false
        this.preferencia = null
      }
    },
    crudPasajeros (tipo, pasajero) {
      if (tipo === 'nuevo') {
        this.pasajero = {
          cantidad: null,
          precio: null
        }
        this.nuevoPasajero = true
        this.dialogPasajeros = true
      } else if (tipo === 'editar') {
        this.pasajero = pasajero
        this.indexPasajero = this.tours.pasajeros.indexOf(pasajero)
        this.dialogPasajeros = true
        this.nuevoPasajero = false
      } else if (tipo === 'publicar') {
        this.tours.pasajeros.push(this.pasajero)
        this.dialogPasajeros = false
        this.preferencia = null
      } else if (tipo === 'actualizar') {
        this.tours.pasajeros[this.indexPasajero] = this.pasajero
        this.dialogPasajeros = false
        this.pasajero = null
      }
    },
    crudHorarios (tipo, horario) {
      if (tipo === 'nuevo') {
        this.horario = null
        this.nuevoHorario = true
        this.dialogHorarios = true
      } else if (tipo === 'editar') {
        this.horario = horario
        for (let i = 0; i < this.tours.horarios.length; i++) {
          if (this.tours.horarios[i] === horario) {
            this.indexHorario = i
          }
        }
        this.dialogHorarios = true
        this.nuevoHorario = false
      } else if (tipo === 'publicar') {
        this.tours.horarios.push(this.horario)
        this.dialogHorarios = false
        this.horario = null
      } else if (tipo === 'actualizar') {
        this.tours.horarios[this.indexHorario] = this.horario
        this.dialogHorarios = false
        this.horario = null
      }
    },
    actualizarTours () {
      this.setCargandoAccion(true)
      if (this.preImagenTours) {
        this.subirImagen(this.preImagenTours, 'utilidades').then(url => {
          this.tours.imagen = url
          firebase.firestore().collection('utilidades').doc('tours').update(this.tours).then(() => {
            this.setCargandoAccion(false)
            this.setAlerta()
            this.setTextoAlerta('Tours Actualizados Correctamente')
            this.dialogTours = false
          })
        })
      } else {
        firebase.firestore().collection('utilidades').doc('tours').update(this.tours).then(() => {
          this.setCargandoAccion(false)
          this.setAlerta()
          this.setTextoAlerta('Tours Actualizados Correctamente')
          this.dialogTours = false
        })
      }
    },
    actualizarGift (numero) {
      if (numero === '1') {
        if (this.preCard1) {
          this.cargando1 = true
          this.subirImagen(this.preCard1, 'utilidades/giftcard').then(url => {
            firebase.firestore().collection('utilidades').doc('giftcard').update({ card1: url }).then(() => {
              this.disenos.card1 = url
              this.setAlerta()
              this.setTextoAlerta('GiftCard Actualizada Correctamente')
              this.cargando1 = false
            })
          })
        }
      } else if (numero === '2') {
        if (this.preCard2) {
          this.cargando2 = true
          this.subirImagen(this.preCard2, 'utilidades/giftcard').then(url => {
            firebase.firestore().collection('utilidades').doc('giftcard').update({ card2: url }).then(() => {
              this.disenos.card2 = url
              this.setAlerta()
              this.setTextoAlerta('GiftCard Actualizada Correctamente')
              this.cargando2 = false
            })
          })
        }
      } else if (numero === '3') {
        if (this.preCard2) {
          this.cargando3 = true
          this.subirImagen(this.preCard2, 'utilidades/giftcard').then(url => {
            firebase.firestore().collection('utilidades').doc('giftcard').update({ card2: url }).then(() => {
              this.disenos.card2 = url
              this.setAlerta()
              this.setTextoAlerta('GiftCard Actualizada Correctamente')
              this.cargando3 = false
            })
          })
        }
      }
    }
  },
  computed: {
    ...mapGetters(['getCargandoAccion'])
  }
}
</script>
